import e from "react";
import { Icon as t } from "../../../general/Icon/Icon.js";
import { Button as i } from "../../../buttons/Button/Button.js";
import { t as n } from "../../../../i18/index.js";
import a from "../../../../../node_modules/dayjs/dayjs.min.js";
function l(l) {
  var o = l.title,
    s = l.description,
    c = l.iframe,
    r = l.date,
    m = l.onClick,
    d = l.onClickReturn,
    _ = l.tag,
    v = l.tagColors,
    g = l.singleVideoSidebar,
    u = l.link,
    f = a(r).format("MMM DD, YYYY"),
    p = _.filter(function (e) {
      return "Suggested" !== e;
    });
  return e.createElement("div", {
    className: "itc-video-single__card",
    onClick: m
  }, !g && e.createElement("div", {
    className: "itc-video-single__return",
    onClick: d
  }, e.createElement(t, {
    fw: !0,
    regular: !0,
    className: "itc-video-single__chevron",
    name: "chevron-left"
  }), e.createElement("span", null, " ", n("back-to-tutorials"), " ")), e.createElement("div", {
    className: "itc-video-single__iframe",
    dangerouslySetInnerHTML: c
  }), e.createElement("div", {
    className: "itc-video-single__info"
  }, e.createElement("div", {
    className: "itc-video-single__title-button"
  }, e.createElement("span", {
    className: "itc-video-single__title"
  }, o, v && (null == p ? void 0 : p.map(function (t, i) {
    return e.createElement("span", {
      key: i,
      className: "itc-video-single__tag itc-video__tag--" + v[t]
    }, t);
  })), " "), e.createElement(i, {
    className: "itc-video-single__open-in-vimeo"
  }, e.createElement("a", {
    className: "itc-video-single__vimeo-link",
    target: "_blank",
    href: u
  }), n("view-in-new-tab"))), e.createElement("span", {
    className: "itc-video-single__date"
  }, f), e.createElement("span", {
    className: "itc-video-single__description"
  }, s)));
}
export { l as SingleVideoView };